/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { ValuesOf } from '@tmapy/beetlejuice-utils';

/**
 * ```yaml
 * type: string
 * description: |-
 *   * `DSPS` - DSPS
 *   * `GP` - GP
 *   * `SURVEYING` - Surveying
 * ```
 */
export const DocumentationTypeEnum = { DSPS: 'DSPS', GP: 'GP', SURVEYING: 'SURVEYING' } as const;
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type DocumentationTypeEnum = ValuesOf<typeof DocumentationTypeEnum>;

export type DocumentationTypeEnumRequest = DocumentationTypeEnum;
export type DocumentationTypeEnumResponse = DocumentationTypeEnum;
